import { createApp } from "vue";
import CommunityTalkMaster from "@/components/communityTalk/CommunityTalkMaster.vue";
import AppConst from "@/modules/const";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default class CommunityTalkLoader {
	/**
	 * Community-Talkトークルームタグの読み取り
	 * コンポーネントのマウントを行う
	 */
	static load(): void {
		const rootComponent = CommunityTalkMaster;

		// 画面上にある"revico-community-talk"タグを読み取り、コンポーネントをマウント
		const elements = document.querySelectorAll(AppConst.COMMUNITY_TALK_TAG);
		elements.forEach((element, i) => {
			// inject用のKeyを生成
			const communityTalkStoreKey: string = i.toString() + "_communityTalkStore";
			// ルートコンポーネントをマウント、inject用のKeyも渡す
			const app = createApp(rootComponent, { targetElement: element, communityTalkStoreKey: communityTalkStoreKey });

			// FontAwesomeをVueで使えるようにする
			app.component("font-awesome-icon", FontAwesomeIcon);
			app.mount(element);
		});
	}
}
